import React, { useRef, useEffect } from "react";
import "./Contact.css";
import emailjs from "emailjs-com";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  const form = useRef();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_jp5nwgi", // Your service ID
        "template_hxbxy8f", // Your template ID
        form.current,
        "jWY89EZgjMPu-DrKc" // Your public key
      )
      .then(
        () => {
          alert("✅ Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          console.error("❌ Error sending message:", error);
          alert("❌ Failed to send message. Please try again later.");
        }
      );
  };

  return (
    <section className="contact-section" data-aos="fade-up">
      <h2 className="contact-heading" data-aos="zoom-in">
        Contact Us
      </h2>
      <span className="contact-underline" data-aos="fade-right"></span>

      <div className="contact-container">
       
        <div className="contact-info" data-aos="fade-right">
          <div className="contact-details">
            <p><strong>Email:</strong> info@vs-solutions.org </p>
            <p><strong>Phone:</strong> +91 7075133814</p>
            <p><strong>Office Address 1:</strong> Ayyappa Society, Mega Hills, Madhapur, Hyderabad, Telangana 500081, India</p>
            <p><strong>Office Address 2:</strong> Guntur, Andhra Pradesh, India</p>
          </div>

          <div className="map-container" data-aos="zoom-in-up">
            <iframe
              title="Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.530051949254!2d78.38721831487627!3d17.44839470558813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93c6c5000001%3A0x6e9c4d5d15c1f8a6!2sMadhapur%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1624427712021!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        
        <div className="contact-form" data-aos="fade-left">
          <form ref={form} onSubmit={sendEmail}>
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <input type="tel" name="phone" placeholder="Mobile Number" required />
            <textarea name="message" placeholder="Your Message" rows="6" required></textarea>
            <button type="submit" className="send-button" data-aos="zoom-in">
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
